import { render, staticRenderFns } from "./electronicLetterCmmmit.vue?vue&type=template&id=0b9d8a08&scoped=true&"
import script from "./electronicLetterCmmmit.vue?vue&type=script&lang=js&"
export * from "./electronicLetterCmmmit.vue?vue&type=script&lang=js&"
import style0 from "./electronicLetterCmmmit.vue?vue&type=style&index=0&id=0b9d8a08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9d8a08",
  null
  
)

export default component.exports